import { Tabs } from "antd";
import React from "react";
import { CM, FL, ML, PA, PFA, SM } from "../../../../../router/AddRoutesJson";
import { getCurrentRole } from "../../../../../../helpers/authFunctions";
import ProjectInfoForm from "../../fl/fl-form/ProjectInfoForm";
import ClientsForm from "../../../clients/ClientsForm";

const MlTabs = () => {
  const items = [
    {
      key: "TAB_PROJECT_INFO",
      label: "Project Info",
      children: <ProjectInfoForm />,
      role: [PA, PFA, FL, ML, SM, CM],
    },
    {
      key: "TAB_CLIENT",
      label: "Clients",
      children: <ClientsForm />,
      role: [PA, PFA, FL, ML, SM, CM],
    },
  ];
  const currentRole = getCurrentRole();

  const filteredItems = items.filter((item) =>
    item?.role?.includes(currentRole)
  );

  return (
    <div className="crd-wrap">
      <Tabs centered items={filteredItems} />
    </div>
  );
};

export default MlTabs;
